import columns from '../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NumberColumn,
    BooleanColumn,
    WarningSignColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new WarningSignColumn(
          'Alert',
          'balanceOnHand',
          true,
          {
            compareLeft: 'minBohThreshold',
            compareRight: 'maxBohThreshold',
          },
        ).withWidth(55),
        new TextColumn('Operator', 'operator'),
        new TextColumn('IMPC', 'impc'),
        new NumberColumn('Minimum BoH threshold', 'minBohThreshold'),
        new NumberColumn('Maximum BoH threshold', 'maxBohThreshold'),
        new NumberColumn('Balance on Hand', 'balanceOnHand'),
        new BooleanColumn('Central point of entry', 'centralEntryPoint'),
      ],
    },
  ];
};
